import React from 'react';
import { Text } from '@fluentui/react-components';

interface FooterProps {
  visitCount?: number | null;
}

export const Footer: React.FC<FooterProps> = ({ visitCount }) => {
  return (
    <footer
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        marginTop: 24,
        fontSize: 12,
        color: '#666',
        alignItems: 'center',
      }}
    >
      <Text size={200} style={{ opacity: 0.6, marginTop: 0 }}>
        NHE News
      </Text>

      {visitCount !== null && visitCount !== undefined && (
        <Text size={200} style={{ opacity: 0.6, marginTop: 0 }}>
          R20 👀 {visitCount.toLocaleString()} visits
        </Text>
      )}

      <a href="/policy" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      <a href="/terms" target="_blank" rel="noopener noreferrer">
        Terms of Service
      </a>
      <a href="/contact" target="_blank" rel="noopener noreferrer">
        Contact Us
      </a>

    </footer>
  );
};
